import { routes } from "@/routes/utils";
import {
  FileClockIcon,
  FileText,
  Fingerprint,
  Gauge,
  LayoutDashboardIcon,
  UserRound,
  TriangleAlert,
  UsersRoundIcon,
  UsersRound,
} from "lucide-react";

export const menus = [
  {
    to: `/${routes.admin}/${routes.activityDashboard}`,
    title: "Activity Dashboard",
    icon: Gauge,
  },
  {
    to: `/${routes.admin}/${routes.adminConsole}`,
    title: "Admin Console",
    icon: UsersRoundIcon,
    children: [
      {
        to: `/${routes.admin}/${routes.adminConsole}/${routes.communities}`,
        title: "Communities",
      },
      {
        to: `/${routes.admin}/${routes.adminConsole}/${routes.propertyReport}`,
        title: "Property Report",
      },
      {
        to: `/${routes.admin}/${routes.adminConsole}/${routes.ownerReport}`,
        title: "Owners Report",
      },
      {
        to: `/${routes.admin}/${routes.adminConsole}/${routes.userManagement}`,
        title: "User Management",
      },
    ]
  },
  {
    to: `/${routes.admin}/${routes.masterData}`,
    title: "Master Data",
    icon: FileText,
    children: [
      {
        title: "Property Config",
        children: [
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.propertyCategory}`,
            title: "Property Category",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.propertyModel}`,
            title: "Property Model",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.propertyZone}`,
            title: "Property Zone",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.propertyBlock}`,
            title: "Property Block",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.properties}`,
            title: "Property Management",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.documentTypeConfig}`,
            title: "Document Type",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.ocpFeeTypes}`,
            title: "OCP Fee Types",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.ocpDocTypes}`,
            title: "OCP Doc Types",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.ownerChangePackage}`,
            title: "Ownership Change Package",
          },
        ]
      },
      {
        title: 'People',
        children: [
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.owner}`,
            title: "Users",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.propertyOwnership}`,
            title: "Property Ownership",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.employee}`,
            title: "CAM / CAM-A",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.manageBOM}`,
            title: "Manage BM",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.vendorMgmt}`,
            title: "Vendor Management",
          },
        ]
      },
      {
        title: "Financial & Billing",
        children: [
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.insuranceType}`,
            title: "Insurance Type",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.paymentTerm}`,
            title: "Payment Terms",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.paymentMethod}`,
            title: "Payment Method",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.billingCategory}`,
            title: "Billing Category",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.glSetup}`,
            title: "GL Setup",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.financialStatementVersions}`,
            title: "Financial Statement Versions",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.budgetMgmt}`,
            title: "Budget Management",
          }
        ]
      },
      {
        title: "Operations",
        children: [
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.incidentType}`,
            title: "Incident Type",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.incidentCategory}`,
            title: "Incident Category",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.announcement}`,
            title: "Announcement",
          },
        ]
      },
      {
        title: 'Compliance & Support',
        children: [
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.stateLaw}`,
            title: "State Law",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.helpDocument}`,
            title: "Help Document",
          },
          {
            to: `/${routes.admin}/${routes.masterData}/${routes.templates}`,
            title: "Template",
          },
        ]
      }
    ],
  },
  {
    to: `/${routes.admin}/${routes.accessMgmt}`,
    title: "Access Management",
    icon: Fingerprint,
  },
  {
    to: `/${routes.admin}/${routes.incidentMgmt}`,
    title: "Incident Management",
    icon: TriangleAlert,
  },
];

export const bomMenus = [
  {
    to: `/${routes.bom}/${routes.dashboard}`,
    title: "Dashboard",
    icon: LayoutDashboardIcon,
  },
  {
    to: `/${routes.bom}/${routes.finance}`,
    title: "Activity Dashboard",
    icon: Gauge,
  },
  {
    to: `/${routes.bom}/${routes.communities}`,
    title: "My Community",
    icon: UsersRoundIcon,
  },
  {
    to: `/${routes.bom}/${routes.masterData}`,
    title: "Master Data",
    icon: FileText,
    children: [
      {
        title: "Property Config",
        children: [
          {
            to: `/${routes.bom}/${routes.masterData}/${routes.propertyCategory}`,
            title: "Property Category",
          },
          {
            to: `/${routes.bom}/${routes.masterData}/${routes.propertyModel}`,
            title: "Property Model",
          },
          {
            to: `/${routes.bom}/${routes.masterData}/${routes.propertyZone}`,
            title: "Property Zone",
          },
          {
            to: `/${routes.bom}/${routes.masterData}/${routes.propertyBlock}`,
            title: "Property Block",
          },
        ]
      },
      {
        title: "Financial & Billing",
        children: [
          {
            to: `/${routes.bom}/${routes.masterData}/${routes.insuranceType}`,
            title: "Insurance Type",
          },
          {
            to: `/${routes.bom}/${routes.masterData}/${routes.paymentTerm}`,
            title: "Payment Terms",
          },
          {
            to: `/${routes.bom}/${routes.masterData}/${routes.paymentMethod}`,
            title: "Payment Method",
          },
          {
            to: `/${routes.bom}/${routes.masterData}/${routes.billingCategory}`,
            title: "Billing Category",
          },
          {
            to: `/${routes.bom}/${routes.masterData}/${routes.budgetApprovals}`,
            title: "Budget Management",
          },
        ]
      },
      {
        title: "Operations",
        children: [
          {
            to: `/${routes.bom}/${routes.masterData}/${routes.incidentType}`,
            title: "Incident Type",
          },
          {
            to: `/${routes.bom}/${routes.masterData}/${routes.incidentCategory}`,
            title: "Incident Category",
          },
        ]
      }
    ],
  },
  {
    to: `/${routes.bom}/${routes.incidentMgmt}`,
    title: "Incident Management",
    icon: TriangleAlert,
  },
  {
    to: `/${routes.bom}/${routes.helpDocument}`,
    title: "Help Document",
    icon: FileText,
  },
];

export const ownerMenu = [
  {
    to: `/${routes.owner}/${routes.dashboard}`,
    title: "Dashboard",
    icon: LayoutDashboardIcon,
  },
  {
    to: `/${routes.owner}/${routes.communities}`,
    title: "My Community",
    icon: UsersRoundIcon,
  },
  {
    to: `/${routes.owner}/${routes.transactionHistory}`,
    title: "My Transaction History",
    icon: FileClockIcon,
  },
  {
    to: `/${routes.owner}/${routes.incidentMgmt}`,
    title: "Incident Management",
    icon: TriangleAlert,
  },
  {
    to: `/${routes.owner}/${routes.myProfile}`,
    title: "My Profile",
    icon: UserRound,
  },
  {
    to: `/${routes.owner}/${routes.myNeighbors}`,
    title: "My Neighbors",
    icon: UsersRound,
  },
  {
    to: `/${routes.owner}/${routes.helpDocument}`,
    title: "Help Document",
    icon: FileText,
  },
];

export const camMenu = [
  {
    to: `/${routes.cam}/${routes.dashboard}`,
    title: "Dashboard",
    icon: LayoutDashboardIcon,
  },
  {
    to: `/${routes.cam}/${routes.communities}`,
    title: "Communities",
    icon: UsersRoundIcon,
  },
  {
    to: `/${routes.cam}/${routes.masterData}`,
    title: "Master Data",
    icon: FileText,
    children: [
      {
        title: "Property Config",
        children: [
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.propertyCategory}`,
            title: "Property Category",
          },
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.propertyModel}`,
            title: "Property Model",
          },
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.propertyZone}`,
            title: "Property Zone",
          },
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.propertyBlock}`,
            title: "Property Block",
          },
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.properties}`,
            title: "Property Management",
          },
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.propertyReport}`,
            title: "Property Report",
          },
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.documentTypeConfig}`,
            title: "Document Type",
          },
        ]
      },
      {
        title: 'People',
        children: [
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.owner}`,
            title: "Users",
          },
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.propertyOwnership}`,
            title: "Property Ownership",
          },
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.ownerReport}`,
            title: "Owners Report",
          },

          {
            to: `/${routes.cam}/${routes.masterData}/${routes.vendorMgmt}`,
            title: "Vendor Management",
          },
        ]
      },
      {
        title: "Financial & Billing",
        children: [
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.insuranceType}`,
            title: "Insurance Type",
          },
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.paymentTerm}`,
            title: "Payment Terms",
          },
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.paymentMethod}`,
            title: "Payment Method",
          },
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.billingCategory}`,
            title: "Billing Category",
          },
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.glSetup}`,
            title: "GL Setup",
          },
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.budgetMgmt}`,
            title: "Budget Management",
          },
        ]
      },
      {
        title: "Operations",
        children: [
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.incidentType}`,
            title: "Incident Type",
          },
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.incidentCategory}`,
            title: "Incident Category",
          },
          {
            to: `/${routes.cam}/${routes.masterData}/${routes.announcement}`,
            title: "Announcement",
          },
        ]
      }
    ],
  },
  {
    to: `/${routes.cam}/${routes.activityDashboard}`,
    title: "Activity Dashboard",
    icon: Gauge,
  },
  {
    to: `/${routes.cam}/${routes.incidentMgmt}`,
    title: "Incident Management",
    icon: TriangleAlert,
  },
];
